/* ============================================================
   API — cliente de los marcadores del backend (rutas relativas /api/...).
   Los marcadores viven en SQLite en el backend y se sincronizan entre
   dispositivos (ver S-015). Toda función puede lanzar Error con un mensaje
   legible (el backend responde JSON { error, detalle }).
   ============================================================ */

async function pedir(url, opciones = {}) {
  let res;
  try {
    res = await fetch(url, {
      headers: { "Content-Type": "application/json" },
      ...opciones,
    });
  } catch {
    throw new Error("No hay conexión con el servidor.");
  }
  if (!res.ok) {
    let detalle = "";
    try {
      const j = await res.json();
      detalle = j.detalle || j.error || "";
    } catch {
      /* respuesta sin cuerpo JSON */
    }
    throw new Error(detalle || `Error ${res.status}`);
  }
  if (res.status === 204) return null;
  return res.json();
}

export const listarBookmarks = () => pedir("/api/bookmarks");

export const crearBookmark = (url, title) =>
  pedir("/api/bookmarks", { method: "POST", body: JSON.stringify({ url, title }) });

export const renombrarBookmark = (id, title) =>
  pedir(`/api/bookmarks/${encodeURIComponent(id)}`, {
    method: "PATCH",
    body: JSON.stringify({ title }),
  });

export const marcarUsoBookmark = (id) =>
  pedir(`/api/bookmarks/${encodeURIComponent(id)}`, {
    method: "PATCH",
    body: JSON.stringify({ used: true }),
  });

export const borrarBookmark = (id) =>
  pedir(`/api/bookmarks/${encodeURIComponent(id)}`, { method: "DELETE" });
